import React, { useEffect, useState } from 'react';
import { useUserInfoQuery } from '../lib/Queries';
import { post, userApiRoute } from '../lib/Api';
import { Link, redirect, useNavigate } from 'react-router-dom';
import RequiresAuth from '../components/RequiresAuth.jsx';
import Loading from '../components/Loading';
import useCreateBusiness from '../lib/useCreateBusiness.jsx';
import { getLastBusinessId } from '../lib/BusinessHelpers.js';
import BusinessLogoSmall from '../components/BusinessLogoSmall.jsx';
import { ChevronRightIcon } from '@heroicons/react/24/outline/index.js';
import AddSquareIcon from '../components/icons/AddSquareIcon.jsx';
import LogoutIcon from '../components/icons/LogoutIcon.jsx';
import NewBusiness2025 from '~/components/onboarding/NewBusiness2025';

const IndexPage = ({}) => {
    const navigate = useNavigate();
    const [showNewBusiness, setShowNewBusiness] = useState(false);
    const { data, isLoading, isRefetching } = useUserInfoQuery();
    const businesses = data?.businesses || [];

    function createBusiness() {
        setShowNewBusiness(true);
    }

    useEffect(() => {
        // Nothing! Prompt to create a new one
        // there is a brief moment after Loading when data still isn't there
        if (isRefetching) {
            return;
        }

        if (Array.isArray(data?.businesses) && businesses.length === 0) {
            setShowNewBusiness(true);
        } else if (businesses.length === 1) {
            // Redirect to our 1 business
            navigate(`/business/${businesses[0].id}`);
        }
    }, [data, businesses.length, isLoading, isRefetching]);

    useEffect(() => {
        if (localStorage.getItem('redirect-after-login')) {
            const redirectTo = localStorage.getItem('redirect-after-login');
            localStorage.removeItem('redirect-after-login');
            setTimeout(() => {
                if (redirectTo !== window.location.pathname) {
                    navigate(redirectTo);
                }
            }, 250);
        } else if (getLastBusinessId()) {
            const lastBusinessId = getLastBusinessId();
            navigate(`/business/${lastBusinessId}`);
        }
    }, []);

    return (
        <RequiresAuth>
            <div className="flex flex-col items-center justify-center min-h-screen w-full bg-gray-100">
                <div>
                    {!isLoading && (
                        <>
                            <h2 className="ml-4 mb-3 text-xl">
                                Select Business
                            </h2>
                            <div className="panel">
                                {businesses.map((business, idx) => (
                                    <div
                                        key={business.id}
                                        className="group ml-4 flex items-center cursor-pointer"
                                        onClick={() =>
                                            navigate(`/business/${business.id}`)
                                        }
                                    >
                                        <BusinessLogoSmall
                                            business={business}
                                            className="mr-3"
                                        />
                                        <div
                                            className={`flex-1 py-4 pr-4 ${idx !== 0 ? `border-t` : ''} flex items-center justify-between`}
                                        >
                                            <div className="text-lg">
                                                {business.name}
                                            </div>
                                            <ChevronRightIcon className="text-gray-400 group-hover:text-gray-500 w-6 h-6 ml-4" />
                                        </div>
                                    </div>
                                ))}
                                {businesses.length === 0 && (
                                    <div>
                                        You are not a part of any businesses
                                    </div>
                                )}
                            </div>
                            <div>
                                <div
                                    className="group panel mb-6 mt-4 pl-4 text-primary-700 flex items-center cursor-pointer"
                                    onClick={createBusiness}
                                >
                                    <AddSquareIcon className="w-6 h-6 mr-3" />
                                    <div
                                        className={`flex-1 py-4 pr-4 flex items-center justify-between`}
                                    >
                                        <div className="text-lg">
                                            Create a New Business
                                        </div>
                                        <ChevronRightIcon className="text-gray-400 group-hover:text-gray-500 w-6 h-6 ml-4" />
                                    </div>
                                </div>
                                <NewBusiness2025
                                    onClose={
                                        businesses.length > 0
                                            ? () => setShowNewBusiness(false)
                                            : null
                                    }
                                    isOpen={showNewBusiness}
                                />
                            </div>
                        </>
                    )}
                    {isLoading && <Loading />}
                </div>
                <Link
                    to={'/logout'}
                    className="btn-gray-pill fixed bottom-5 left-5 flex items-center"
                >
                    <LogoutIcon className="w-5 h-5 mr-2" />
                    Logout
                </Link>
            </div>
        </RequiresAuth>
    );
};

export default IndexPage;
